import { Breadcrumb, Button, Col, Row } from "antd";
import React, { useState } from "react";
import KycModal_1 from "../../../pages/accountVerification/view/layout_2/component/kycModal";
import { useRecoilValue } from "recoil";
import {
  globalBreadCrumbState,
  globalUserDetailState,
} from "../../../_common/global_state";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useShared from "../../../_common/_shared";

export const Breadcrumb_1 = ({ kybList, poiList, porList }) => {
  const navigate = useNavigate();
  const hash = window.location.hash;
  const currentPath = hash.substring(1);
  const splitPath = currentPath.split("?")[0];
  const [openKycModal, setOpenKycModal] = useState(false);
  const globalBreadCrumb = useRecoilValue(globalBreadCrumbState);
  const { t } = useTranslation();

  const { IconModule } = useShared();

  function convertToTitleCase(str) {
    const withoutSlash = str.slice(1);
    const words = withoutSlash.split("-");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    return capitalizedWords.join(" ");
  }

  const pageHeader = globalBreadCrumb[globalBreadCrumb?.length - 1];

  const breadcrumbItems =
    Array.isArray(globalBreadCrumb) &&
    globalBreadCrumb?.length > 0 &&
    globalBreadCrumb?.map((item, index) => {
      return {
        title: (
          <div
            className={"clickable"}
            style={
              index === globalBreadCrumb.length - 1
                ? { color: "var(--hover-active-color)" }
                : { color: "var(--text-color)" }
            }
            onClick={() => navigate(item?.path)}
          >
            {t(
              `module.${item?.name
                ?.replace(".", "")
                .replace(/[-\s+]/g, "_")
                .toLowerCase()}`
            )}
          </div>
        ),
      };
    });

  return (
    <Row className="page-layout">
      <Col span={24} className={"mb-3 mt-3"}>
        <div className="pageHeaderTitle">
          <IconModule
            iconName={`md-${pageHeader?.name
              ?.replace(".", "")
              .replace(/[-\s+]/g, "")
              .toLowerCase()}`}
            layout={1}
            isAlwaysActive={true}
          />
          <div>
            {t(
              `module.${pageHeader?.name
                ?.replace(".", "")
                .replace(/[-\s+]/g, "_")
                .toLowerCase()}`
            )}
          </div>
        </div>
        {/* <Breadcrumb
          className={"mx-auto mx-lg-0"}
          style={{ width: "fit-content" }}
          items={breadcrumbItems}
        /> */}
      </Col>
      <KycModal_1
        isModalOpen={openKycModal}
        handleCancel={() => {
          setOpenKycModal(false);
        }}
        verificationType={"kyb"}
        data={kybList}
        poiList={poiList}
        porList={porList}
      />
    </Row>
  );
};
